module.exports = __webpack_public_path__ + "media/music_4.1e5c440e.mp3";